import React, { useRef, useEffect } from 'react';
import { useEventListener } from 'ahooks';
import { useTempState } from '@starflow/app/store';

const CustomCursorInner = (props) => {
  // 这是一个自定义的鼠标指针组件，通过监听鼠标移动事件，实时更新鼠标指针的位置
  const cursorRef = useRef(null);

  useEventListener('mousemove', (event) => {
    cursorRef.current.style.left = event.clientX + 'px';
    cursorRef.current.style.top = event.clientY - 48 + 'px';
  });

  useEffect(() => {
    // 初始化鼠标指针的位置
    cursorRef.current.style.left = -100;
    cursorRef.current.style.top = -100;

    document.getElementById('canvas-stage-wrapper').style.cursor = 'none';

    return () => {
      document.getElementById('canvas-stage-wrapper').style.cursor = 'inherit';
    };
  }, []);

  return (
    <div ref={cursorRef} className="absolute pointer-events-none">
      {props.children}
    </div>
  );
};

export const CustomCursor = React.memo(() => {
  const CursorComponent = useTempState('cursorComponent');

  if (!CursorComponent) return null;

  return (
    <CustomCursorInner>
      <CursorComponent />
    </CustomCursorInner>
  );
});
